// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSiteListPostRequest {
    static getAttributeTypeMap() {
        return PrescriberSiteListPostRequest.attributeTypeMap;
    }
}
PrescriberSiteListPostRequest.discriminator = undefined;
PrescriberSiteListPostRequest.additionalProperties = false;
PrescriberSiteListPostRequest.attributeTypeMap = [
    {
        "name": "prescriberSiteIds",
        "baseName": "prescriberSiteIds",
        "type": "Array<number>"
    },
];
//# sourceMappingURL=prescriberSiteListPostRequest.js.map